import { z } from "zod";
import { uuid } from "./common.js";
/**
 * The ingestion state machine (Fig 7). Per D-22 this lives on `docs.documents`
 * and nowhere else -- there is no second table mirroring it, so the UI and the
 * worker cannot disagree about what happened.
 */
export const documentStatus = z.enum([
    "uploading", // row exists, waiting on the browser's PUT to S3
    "queued",
    "downloading",
    "parsing",
    "chunking",
    "embedding",
    "indexing",
    "completed",
    "failed", // retryable; attempts < max
    "dead", // attempts exhausted, needs a manual retry
]);
/** Statuses the worker is actively moving through -- the UI polls while in these. */
export const IN_FLIGHT_STATUSES = [
    "queued",
    "downloading",
    "parsing",
    "chunking",
    "embedding",
    "indexing",
];
export const MAX_UPLOAD_BYTES = 20 * 1024 * 1024; // 20 MB (L-12)
export const MAX_PAGES = 200;
export const PDF_MIME = "application/pdf";
export const document = z.object({
    id: uuid,
    filename: z.string(),
    sizeBytes: z.number().int().nonnegative(),
    pageCount: z.number().int().nonnegative().nullable(),
    status: documentStatus,
    /** 0-100, coarse progress within the current stage. */
    progress: z.number().int().min(0).max(100),
    attempts: z.number().int().nonnegative(),
    errorText: z.string().nullable(),
    createdAt: z.string().datetime(),
    ingestedAt: z.string().datetime().nullable(),
});
export const createDocumentRequest = z.object({
    filename: z.string().min(1).max(255),
    sizeBytes: z.number().int().positive().max(MAX_UPLOAD_BYTES),
    contentType: z.literal(PDF_MIME),
});
export const createDocumentResponse = z.object({
    documentId: uuid,
    /** Presigned S3 PUT. The browser uploads directly; bytes never touch our box (D-6). */
    uploadUrl: z.string().url(),
    expiresIn: z.number().int().positive(),
});
/**
 * Marks the upload done and enqueues ingestion. doc-svc HEADs the object first
 * rather than trusting the client that the PUT actually happened, and enqueues
 * with `jobId: documentId` so a double-click produces one job, not two.
 */
export const completeUploadResponse = z.object({
    documentId: uuid,
    status: documentStatus,
});
//# sourceMappingURL=documents.js.map